import { dashIfFalsy } from 'components/JobDetailsSheet/jobsHelper';
import {
  JobDetailsResponse,
  JobSheetDataRowsOptions,
  JobSheetTab,
  JobSheetTabLabels
} from 'models/JobDetails';
import { WorkflowSectionData } from 'models/Workflow';
import {
  getBookingNotesRow,
  getBookingRows,
  getComplaintSectionData,
  getCustomerRows,
  getPreviousAbortRows,
  getPsrVulnerabilitiesRow,
  getTechnicalSectionData,
  getVulnerabilitiesRow
} from 'views/Jobs/JobDetailsConfig';

function getOnTheDayPhoneNumberRow(
  job: JobDetailsResponse
): JobSheetDataRowsOptions {
  return {
    type: 'text',
    label: 'On the day phone number',
    value: dashIfFalsy(job.onTheDayPhoneNumber)
  };
}

export function getJobSheetTabsData(
  job: JobDetailsResponse,
  workflowSections: WorkflowSectionData[]
): JobSheetTab[] {
  return [
    {
      label: JobSheetTabLabels.BookingDetails,
      rows: [
        ...getBookingRows(job, true),
        getOnTheDayPhoneNumberRow(job),
        getVulnerabilitiesRow(job, true, 'list'),
        getBookingNotesRow(job, true, 'list')
      ],
      sections: getComplaintSectionData(job)
    },
    {
      label: JobSheetTabLabels.CustomerDetails,
      rows: [
        ...getCustomerRows(job, true),
        getPsrVulnerabilitiesRow(job, true, 'list')
      ]
    },
    {
      label: JobSheetTabLabels.AccountDetails,
      rows: getTechnicalSectionData(job, true).flatMap(section => section.rows)
    },
    {
      label: JobSheetTabLabels.Workflow,
      workflowSections
    },
    {
      label: JobSheetTabLabels.PreviousAborts,
      previousAbortEntries: getPreviousAbortRows(job, true)
    },
    {
      label: JobSheetTabLabels.AuditHistory,
      auditEntries: job.auditEntries
    }
  ];
}
